import { PaletteColors } from '@fox/atoms';

export interface SwiftFoxGoalsResult {
	total: number;
	results: SwiftFoxGoalWithInferredDates[];
}

export interface SwiftFoxGoal {
	id: string;
	goalId: string;
	ownerType: string;
	ownerId: string;
	createdOn: string;
	startDate: string;
	endDate?: string;
	autoRenew: boolean;
	status: GoalStatus;
	documents?: Attachment[];
	isDeleted?: boolean;
}

export interface PointsInfo {
	categoryName: string;
	categoryId: string;
	catPoints: number;
	catPointsRequired?: number;
	catPointsMax?: number;
}
export interface CalculatedOwnedGoalsPointData {
	totalPoints: number;
	totalPointsRequired: number;
	pointsInfo: PointsInfo[];
	goalAchieved: boolean;
}

export interface SwiftFoxGoalWithInferredDates extends SwiftFoxGoal {
	startDateInferred?: string;
	endDateInferred?: string;
	calculatedPointData: CalculatedOwnedGoalsPointData;
}

export enum GoalInterval {
	Common = 'Common',
	Anniversary = 'Anniversary',
	NeverEnding = 'NeverEnding'
}

export interface SwiftFoxGoalsGoal {
	id: string;
	ownerType: string;
	name: string;
	interval: GoalInterval;
	units?: number;
	commonPeriod?: string;
	totalPointsRequired?: number;
	pointsRequired: PointsTracker[];
	defaultAutoRenew: boolean;
	defaultStart?: string;
}

export enum GoalStatus {
	Active = 'Active',
	Inactive = 'Inactive',
	Cancelled = 'Cancelled'
}
export const GOALS_STATUS: Record<GoalStatus, PaletteColors> = {
	[GoalStatus.Active]: 'success',
	[GoalStatus.Inactive]: 'warning',
	[GoalStatus.Cancelled]: 'error'
};

export interface Attachment {
	blobUrl: string;
	mime: string;
	fileName: string;
	size: number;
}

export interface SwiftFoxGoalsActivitiesResult {
	total: number;
	results: SwiftFoxGoalActivity[];
}

export interface SwiftFoxGoalActivity {
	id: string;
	ownerType: string;
	ownerId: string;
	effectiveDate: string;
	dateRecorded: string;
	dateConfirmed?: string;
	sourceId: string;
	status: GoalActivityStatus;
	points: ActivityPoints[];
	documents?: Attachment[];
	isDeleted?: boolean;
	target?: ActivityTarget;
}

export interface PointsTracker {
	pointCategoryId: string;
	points?: number;
	max?: number;
}

export interface ActivityPoints {
	pointCategoryId: string;
	points: number;
}

export interface ActivityTarget {
	targetType?: string;
	targetId?: string;
	attendanceId?: string;
}

export enum GoalActivityStatus {
	Approved = 'Approved',
	Pending = 'Pending',
	Rejected = 'Rejected'
}

export const ACTIVITY_STATUS: Record<GoalActivityStatus, PaletteColors> = {
	[GoalActivityStatus.Approved]: 'success',
	[GoalActivityStatus.Pending]: 'warning',
	[GoalActivityStatus.Rejected]: 'error'
};

export interface SwiftFoxGoalsPointsSnapshotResult {
	pointsByOwnedGoal: PointsByOwnedGoal[];
	totalPointsAcquired: number;
	totalPointsYTD: PointsTracker[];
}

export interface PointsByOwnedGoal {
	ownedGoalId: string;
	totalPoints: number;
	pointsByCategory: PointsTracker[];
}

export interface SwiftFoxGoalPointsCategory {
	id: string;
	name: string;
}

export interface SwiftFoxGoalsConfig {
	labelOverrides?: GoalsLabelOverrides;
	activitySources?: GoalsActivitySource[];
}

export interface GoalsActivitySource {
	id: string;
	name: string;
	ownerType: string;
}

export interface GoalsLabelOverrides {
	Tab?: string;
	Activity?: string;
	Activities?: string;
	Goal?: string;
	Goals?: string;
}

export interface SwiftFoxExportedField {
	value: string;
	column: string;
}

export interface SwiftFoxExportedRow {
	columns: SwiftFoxExportedField[];
}

export interface UpsertGoalActivityModel {
	id?: string;
	contentId?: string;
	useLinkedOrganisationData?: boolean;
	dateRecorded?: string;
	effectiveDate?: string;
	status?: string;
	pointCategory?: string;
	points?: number;
	source?: GoalsActivitySource;
	sourceId?: string;
	documents?: Attachment[];
	isDeleted?: boolean;
}

export interface UpsertGoalActivityInputModel {
	contentId: string;
	useLinkedOrganisationData?: boolean;
	dateRecorded: string;
	effectiveDate: string;
	status: string;
	points: ActivityPoints[];
	source?: GoalsActivitySource;
	sourceId?: string;
	documents?: Attachment[];
	isDeleted?: boolean;
}

export interface GetSasInputModel {
	contentId: string;
	fileName: string;
}

export interface GetFormSasInputModel extends GetSasInputModel {
	surveyId: number;
}

export interface DeleteGoalActivityInputModel {
	contentId: string;
	id: string;
}
export enum ActivityEditRule {
	All = 'All',
	None = 'None'
}
